import { RegionDailyAveragesService } from '@/backend/market'
import { PaginateEntity } from '@/shared/entities/PaginateEntity'
import type { RegionDailyAverageEntity } from '../../domain/entities/RegionDailyAverageEntity'
import type { RegionDailyAverageFilterEntity } from '../../domain/entities/RegionDailyAverageFilterEntity'
import { RegionDailyAverageRepository } from '../../domain/repositories/RegionDailyAverageRepository'
import { RegionDailyAverageFilterModel } from '../models/RegionDailyAverageFilterModel'
import { RegionDailyAverageModel } from '../models/RegionDailyAverageModel'

export class RegionDailyAverageRepositoryImpl implements RegionDailyAverageRepository {
  async getRegionDailyAverages(
    filterData: RegionDailyAverageFilterEntity
  ): Promise<PaginateEntity<RegionDailyAverageEntity[]> | { error: true }> {
    const filterModel = new RegionDailyAverageFilterModel(filterData)

    try {
      const response = await RegionDailyAveragesService.getRegionDailyAveragesAdmin(filterModel)
      const items = response.items?.map((item) => new RegionDailyAverageModel(item))
      return new PaginateEntity<RegionDailyAverageEntity[]>(
        {
          count: response.count,
          page: response.page ? response.page - 1 : 0,
          limit: response.limit,
          items
        },
        items as unknown as RegionDailyAverageEntity[]
      )
    } catch {
      return { error: true }
    }
  }
}
